import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export const useUniversities = () => {
  const [universities, setUniversities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUniversities = async () => {
      try {
        const universitiesDoc = await getDoc(doc(db, 'master_data', 'universities'));
        
        if (universitiesDoc.exists()) {
          const data = universitiesDoc.data();
          if (data && Array.isArray(data.list)) {
            setUniversities(data.list);
          } else {
            setError('Universities data format is invalid');
          }
        } else {
          setError('Universities data not found');
        }
      } catch (err) {
        console.error('Error fetching universities:', err);
        setError('Failed to load universities');
      } finally {
        setLoading(false);
      }
    };

    fetchUniversities();
  }, []);

  // Function to validate email domain against university domains
  const validateEmailDomain = (email, universityId) => {
    const university = universities.find(uni => uni.id === universityId);
    if (!university) return false;
    
    const emailDomain = email.split('@')[1]?.toLowerCase();
    if (!emailDomain) return false;
    
    return university.domains.includes(emailDomain);
  };

  // Function to get university by email domain
  const getUniversityByEmail = (email) => {
    const emailDomain = email.split('@')[1]?.toLowerCase();
    if (!emailDomain) return null;
    
    return universities.find(uni => 
      uni.domains.includes(emailDomain)
    );
  };

  return {
    universities,
    loading,
    error,
    validateEmailDomain,
    getUniversityByEmail
  };
};